const white = "#FFFFFF";
const black = "#111827"; // gray-900
const muted = "#6b7280"; // gray-500

export const primary = {
  contrastText: white,
  main: "#020617", // blue-950 - corporate navy
  light: "#3b82f6", // blue-500
  dark: "#1e40af", // blue-800
};

const grey = {
  50: "#f9fafb", // gray-50
  100: "#f3f4f6", // gray-100
  200: "#e5e7eb", // gray-200
  300: "#d1d5db", // gray-300
  400: "#9ca3af", // gray-400
  500: "#6b7280", // gray-500
  600: "#4b5563", // gray-600
  700: "#374151", // gray-700
  800: "#1f2937", // gray-800
  900: "#111827", // gray-900
};

const CranecastPalette = {
  grey,
  common: {
    black,
    white,
    neutral: "rgba(243, 244, 246, 0.8)", // light gray overlay
    main: "#020617", // blue-950
    red: "#dc2626", // red-600
    muted: "#6b7280", // gray-500
    gray: "#f3f4f6", // gray-100
    green: "#16a34a", // green-600
    lightgreen: "#22c55e", // green-500
    blue: "#1e40af", // blue-800
    lightblue: "#3b82f6", // blue-500
    fadedBlue: "#60a5fa", // blue-400
    yellow: "#eab308", // yellow-500 - corporate accent
    darkYellow: "#f59e0b", // amber-500
    orange: "#ea580c", // orange-600
    purple: "#7c3aed", // violet-600
  },
  chart: {
    // Updated chart colors for dark theme
    series1: "#60a5fa", // blue-400
    series2: "#22c55e", // green-500
    series3: "#f59e0b", // amber-500
    series4: "#7c3aed", // violet-600
    series5: "#ea580c", // orange-600
    series6: "#06b6d4", // cyan-500
    series7: "#10b981", // emerald-500
    series8: "#84cc16", // lime-500
    series9: "#eab308", // yellow-500
    series10: "#f97316", // orange-500
    series11: "#ef4444", // red-500
    series12: "#8b5cf6", // violet-500
    series13: "#06b6d4", // cyan-500
    series14: "#1e40af", // blue-800
    series16: "#020617", // blue-950
    series17: "#64748b", // slate-500
  },
  cranecastTimeline: {
    idle: "#dc2626", // red-600 - more sophisticated red
    moving: "#16a34a", // green-600
    rigging: "#6b7280", // gray-500 - softer gray
    liftingMoving: "#3b82f6", // blue-500
    liftingOnly: "#1d4ed8", // blue-700
    wind: "#7c3aed", // violet-600
    ticker: "#1e293b", // slate-800
  },
  navigation: {
    active: "#1e293b", // slate-800
    background: "#0f172a", // slate-900
    activeText: "#60a5fa", // blue-400
    inactiveText: "#cbd5e1", // slate-300
  },
  primary,
  secondary: {
    contrastText: white,
    main: "#eab308", // yellow-500 - corporate accent
    light: "#fbbf24", // amber-400
    dark: "#d97706", // amber-600
  },
  success: {
    contrastText: white,
    main: "#16a34a", // green-600
    light: "#dcfce7", // green-50
    dark: "#14532d", // green-900
  },
  info: {
    contrastText: white,
    main: "#0ea5e9", // sky-500
    light: "#e0f2fe", // sky-50
    dark: "#0c4a6e", // sky-900
    buttonBackground: "#dbeafe", // blue-100
    buttonForeground: "#2563eb", // blue-600
  },
  warning: {
    contrastText: white,
    main: "#f59e0b", // amber-500
    light: "#fef3c7", // amber-100
    dark: "#d97706", // amber-600
  },
  danger: {
    contrastText: white,
    main: "#dc2626", // red-600
    light: "#fef2f2", // red-50
    dark: "#991b1b", // red-800
  },
  text: {
    primary: "#111827", // gray-900 - dark text for light theme
    secondary: "#6b7280", // gray-500
    tertiary: "#020617", // blue-950
    disabled: "#9ca3af", // gray-400
    link: "#1e40af", // blue-800
  },
  background: {
    default: "#ffffff", // pure white background
    dark: "#fcfdfe", // very light gray for cards
    paper: "#fcfdfe", // very light gray for widget cards
  },
  caption: {
    text: "#6b7280", // gray-500
  },
  polygon: {
    border: "rgba(255, 255, 255, 0.8)",
    fill: "#16a34a", // green-600
  },
  heatmap: {
    complete: "#16a34a", // green-600
    weatherDelay: "#dc2626", // red-600
    forecast: "#64748b", // slate-500
    vacant: "#e2e8f0", // slate-200
    cycleOnTrack: "#16a34a", // green-600
    cycleVariance1: "#f59e0b", // amber-500
    cycleVariance2: "#dc2626", // red-600
    currentDay: {
      primary: "#1e40af", // blue-800
      secondary: "#3b82f6", // blue-500
      border: "#60a5fa", // blue-400
    },
  },
  border: "#e5e7eb", // gray-300 - more visible border
  divider: "#e5e7eb", // gray-300
  errorColor: "#dc2626", // red-600
  orderStatus: {
    default: "#475569", // slate-600
    orderPlaced: "#f59e0b", // amber-500
    supplierConfirmed: "#16a34a", // green-600
    rescheduling: "#dc2626", // red-600
    delivered: "#0ea5e9", // sky-500
  },
};

export default CranecastPalette;